module.exports = __webpack_public_path__ + "img/sports_saba.1b943a19.png";